import React, { ReactElement } from "react";
import { Badge } from "@twilio-paste/core/badge";
import { Box } from "@twilio-paste/core/box";
import { animated, useSpring } from "@twilio-paste/core/animation-library";

import {
  ToolCallStatusLineBlock,
  dataTestIds,
  WiseOwlElementIds,
} from "@twiliointernal/e2-commons-shared-definitions";
import { useWiseOwlContext } from "../../../hooks";

interface ToolCallStatusLineProps {
  block: ToolCallStatusLineBlock;
}

const AnimatedBadge = animated(Badge);

const ToolCallStatusLine = ({
  block,
}: ToolCallStatusLineProps): ReactElement => {
  const {
    applicationProps: { displayName },
    loadingConfiguration,
  } = useWiseOwlContext();
  const { content } = block.values;

  const springs = useSpring({
    from: {
      opacity: loadingConfiguration.submission ? 0 : 1,
      transform: loadingConfiguration.submission
        ? "translateX(-5%)"
        : "translateX(0%)",
    },
    to: {
      opacity: loadingConfiguration.submission ? 1 : 0,
      transform: loadingConfiguration.submission
        ? "translateX(0%)"
        : "translateX(-5%)",
    },
  });

  return (
    <Box
      element={WiseOwlElementIds.WISE_OWL_TOOL_CALL_STATUS_LINE_BLOCK}
      marginBottom="space30"
      data-testid={dataTestIds.wiseOwlChat.toolCallStatusLine}
    >
      <AnimatedBadge as="span" variant="neutral" style={{ ...springs }}>
        {`${displayName} is `}
        {content.toLowerCase()}...
      </AnimatedBadge>
    </Box>
  );
};

export default ToolCallStatusLine;
